import './css/reset.css'
import './style.css'

console.log('Hello from Vite!');

const $body = document.querySelector('body');
console.log($body.getAttribute('page'));

switch ($body.getAttribute('page')) {
  case 'info':
    import('./info.js')
    break;
  case 'game':
    import('./game.js')
    break;
  default:
    break;
}

